import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';

/**
 * Reads the first-login catchup-sync gate state.
 *
 * `isCatchupActive` is true only when the tenant has opted in
 * (ENABLE_CATCHUP_SYNC) AND the persisted status reads `pending`.
 * Terminal statuses (`complete | failed | skipped`) drop the gate, as
 * does an absent status (we don't gate the user on something we have
 * no record of).
 */
export function useCatchupSync() {
  const { session } = useAuth();
  const { getConfigValue } = useTenant();

  const tenantEnabled = getConfigValue<boolean>('ENABLE_CATCHUP_SYNC') === true;
  const status = session?.metadata?.catchupSync;
  const state = status?.state;
  const isCatchupActive = tenantEnabled && state === 'pending';

  return { isCatchupActive, state, status, tenantEnabled };
}
